import React from 'react';
import HomePage from './pages/HomePage';
import AdminApp from './admin/AdminApp';

// No router needed for two pages. Firebase Hosting rewrites every path to
// index.html, so /admin lands here and we branch on the pathname.
export default function App() {
  const isAdmin = window.location.pathname.replace(/\/+$/, '') === '/admin';
  return isAdmin ? <AdminApp /> : <HomePage />;
}
